export default __webpack_public_path__ + "static/media/computer.d23e5dd2.png";